import { UseFormSetError } from "react-hook-form";

import UserFormContent, {
  UserFormContentData,
  UserFormContentProps,
} from "../UserForm";

import { CreateUserRequest } from "@/types/request/CreateUserRequest";
import { EditUserRequest } from "@/types/request/EditUserRequest";

type AddUserFormProps = {
  options: UserFormContentProps["options"];
  isSubmitting: boolean;
  onSubmitForm: (
    payload: CreateUserRequest,
    setError?: UseFormSetError<UserFormContentData>,
  ) => void;
  onSuccess?: () => void;
};

const AddUserForm: React.FC<AddUserFormProps> = ({
  options,
  isSubmitting,
  onSubmitForm,
  onSuccess,
}) => {
  const handleSubmit = (
    payload: EditUserRequest | CreateUserRequest,
    setError?: UseFormSetError<UserFormContentData>,
  ) => {
    onSubmitForm(payload as CreateUserRequest, setError);
  };

  return (
    <UserFormContent
      type="create"
      options={options}
      isSubmitting={isSubmitting}
      onSubmitForm={handleSubmit}
      onSuccess={onSuccess}
    />
  );
};

export default AddUserForm;
